var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-image',{staticClass:"container pt-4",staticStyle:{"width":"180px"},attrs:{"src":_vm.imageUrl}}),_c('decimal-converter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }